import { IconButton, Tooltip, useMediaQuery, useTheme } from "@material-ui/core"
import { Delete } from "@material-ui/icons"
import LinkIcon from "@material-ui/icons/Link"
import { Video } from "cloudinary-react"
import PropTypes from "prop-types"
import React, { useCallback, useContext, useState } from "react"
import { uploadCloudinaryVideo } from "~/actions/upload"
import EditIcon from "~/assets/Icons/edit-icon.svg"
import AppContext from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"

import Box from "~/components/Common/Box"
import FileUpload from "../FileUpload"
import PermissionsWrapper from "../PermissionsWrapper"
import useStyles from "./styles"

const CloudinaryVideoUpload = ({ value, onUpload, typeExpected, type }) => {
  const theme = useTheme()
  const phoneView = useMediaQuery(theme.breakpoints.down("sm"))

  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  // if typeExpected
  // See if acceptedFiles.type matches type expected
  // if not, return a false value that triggers snackbar orrrrrrr use state
  const { openSnackBar, openDialog } = useContext(AppContext)
  const openErrorSnackbar = useOpenErrorSnackbar()
  let myRef = React.createRef()
  //myRef.current is null???
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (typeExpected.length > 0) {
        if (`video/${typeExpected}` !== acceptedFiles[0].type) {
          openSnackBar({ message: "File Dropped is not of Correct Type" })
          return
        }
      }
      setLoading(true)
      uploadCloudinaryVideo(acceptedFiles[0])
        .then((uploadRes) => {
          onUpload(uploadRes)
          setLoading(false)
        })
        .catch((err) => {
          openErrorSnackbar(err, "Cloudinary Upload Error")
          setLoading(false)
          console.error(err)
        })
    },
    [onUpload],
  )
  const playPause = () => {
    const video = myRef.current //get the video element
    video.play()
    video.pause()
  }

  const renderDeleteImage = () => {
    return (
      <Tooltip title="Delete Image" placement="top">
        <IconButton
          className={classes.delete}
          color="inherit"
          style={{ zIndex: "10" }}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            openDialog("deleteImageDialog", {
              onUpload,
              setLoading,
              type,
            })
          }}
        >
          <Delete style={{ color: "red" }} />
        </IconButton>
      </Tooltip>
    )
  }

  const renderCopyImage = () => {
    return (
      <Tooltip title="Copy Image" placement="top">
        <IconButton
          className={classes.copyImage}
          color="inherit"
          style={{ zIndex: "10" }}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            navigator.clipboard.writeText(value?.url)
            openSnackBar({ message: "Image URL copied to clipboard" })
          }}
        >
          <LinkIcon style={{ color: "white" }} />
        </IconButton>
      </Tooltip>
    )
  }
  return (
    <FileUpload
      title="Drop video here"
      onDrop={onDrop}
      showLoading={loading}
      accepted="video/*"
      onError={(error) => {
        openErrorSnackbar(error, "Error Uploading Video, Files Rejected")
        console.error("error: ", error)
      }}
    >
      {value && (
        <Box className={classes.thumbnailBox}>
          <PermissionsWrapper permissionGroup="admin">
            {renderDeleteImage()}
          </PermissionsWrapper>
          {renderCopyImage()}
          <PermissionsWrapper permissionGroup="admin">
            <Box className={classes.editBox}>
              <img src={EditIcon} alt="Edit video" style={{ width: 24 }} />
              {/* <PlayCircleOutlineIcon
              style={{ width: 24, color: "white" }}
              onClick={playPause}
            /> */}
            </Box>
          </PermissionsWrapper>
          <Video
            innerRef={myRef}
            autoPlay={phoneView ? false : true}
            muted
            loop={true}
            publicId={value.public_id}
            style={{ verticalAlign: "bottom", width: "100%" }}
          />
        </Box>
      )}
    </FileUpload>
  )
}

CloudinaryVideoUpload.propTypes = {
  value: PropTypes.object,
  onUpload: PropTypes.func.isRequired,
  typeExpected: PropTypes.string,
  type: PropTypes.string,
}

export default CloudinaryVideoUpload
